export default __webpack_public_path__ + "static/media/floor-restoration.544e7a59.png";